import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { StickCricketGameCoreService } from './stick-cricket-game-core.service';
import { StickCricketGameSelectorComponent } from './stick-cricket-game-selector/stick-cricket-game-selector.component';

@NgModule({
  declarations: [StickCricketGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [StickCricketGameCoreService],
  exports: [StickCricketGameSelectorComponent],
})
export class StickCricketGameCoreModule {}
